import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const organization='';

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  resources: {
    en: {
      translations: {
        agentKeyName:organization?.agentKeyName
          ? organization?.agentKeyName
          : "Agent",
      },
    },
    es: {
      translations: require("./locales/hin/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "es"];

export default i18n;
